import React from 'react';

import ArrowUpRotate from '../../../assets/arrow-up-rotate-icon';

const Card = ({ title, sourceImage, onClick, isWithBorder = false }) => {
  return (
    <div className={`w-full bg-white ${isWithBorder && 'border border-gray-200'} rounded-lg`}>
      <img className="rounded-t-lg h-[210px] w-full" src={sourceImage} alt={title} />
      <div className="px-8 py-5 flex justify-between items-center">
        <h5 className="text-left mb-2 text-xl tracking-tight text-gray-900">{title}</h5>
        <button
          onClick={onClick}
          className="inline-flex items-center px-3 text-center bg-[#0AB7F1] rounded-full w-[48px] h-[48px]"
        >
          <ArrowUpRotate />
        </button>
      </div>
    </div>
  );
};

export default Card;
